(() => {
  const { dataLayer, ua } = window;
  const trackingDisabled = !window.trackingEnabled;

  const upsellListName = 'Upsell overlay';
  const upsellInCartListName = 'Upsell cart';
  const favoritesListName = 'Favorites list';
  const relatedProductsListName = 'Related Products Product Page';

  const isTrackingDisabled = () => trackingDisabled;
  const mockTrackingApp = {
    always(callback) {
      if (typeof callback === 'function') {
        callback();
      }
    },
    then(callback) {
      if (typeof callback === 'function') {
        callback();
      }
    },
  };

  let debouncedPush;
  let impressionsQueue = [];

  const analyticsCache = {};
  const analyticsCacheAdd = (productInformation) => (
    productInformation.forEach((product) => {
      analyticsCache[product.productId] = product;
    })
  );
  const analyticsCacheGet = (productId) => (
    productId ? analyticsCache[productId] : analyticsCache
  );

  const impressionRecord = {};
  const saveTrackedImpression = (product) => {
    impressionRecord[`${product.id}_${product.listName}`] = true;
  };
  const impressionAlreadyTracked = (product) => (
    !!impressionRecord[`${product.id}_${product.listName}`]
  );

  function stripTags(content) {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    return doc.body.textContent || '';
  }

  const getRibbon = (product, defaultValue) => {
    let ribbon = defaultValue || 'no ribbon';
    if (product.ribbon) {
      const ribbonText = typeof product.ribbon?.text === 'string' ? product.ribbon.text : product.ribbon;
      ribbon = stripTags(ribbonText);
      if (product.isOnSaleProduct) {
        ribbon = `${ribbon}|Last chance`;
      }
    }
    return ribbon;
  };

  async function fetch(data) {
    try {
      const response = await $.ajax({
        url: '/analytics',
        data: JSON.stringify(data),
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      });
      analyticsCacheAdd(response.productInformation);
      return response;
    } catch (e) {
      App.sendErrorToRaygun(e);
    }
    return {};
  }

  function addCustomProperties(src, dest, propsArray) {
    propsArray.forEach((prop) => {
      if (App.global.objHasProp(src, prop)) {
        /* eslint-disable no-param-reassign */
        if (prop === 'addToCartDate') {
          dest.details = dest.details || src.details || {};
          dest.details[prop] = new Date(src[prop]).toLocaleDateString('sv');
        } else {
          dest[prop] = src[prop];
        }
        /* eslint-enable no-param-reassign */
      }
    });
  }

  const getListName = function ($elem) {
    const GENERIC_LIST_NAME = ua ? ua.listName : '';
    if (!($elem instanceof window.jQuery)) {
      return GENERIC_LIST_NAME;
    }

    const isUpsellInCartPopup = $elem.closest('[data-upsell-in-cart]').length;
    if (isUpsellInCartPopup) {
      return upsellInCartListName;
    }

    const $productGroupModule = $elem.closest('[data-component="productGroupModule"]');
    if ($productGroupModule.length) {
      return `${ua.listName} - Product Group Module - ${$productGroupModule.attr('data-slug')}`;
    }

    const isRelatedProducts = $elem.closest('.product-page__related-products').length;
    if (isRelatedProducts) {
      return relatedProductsListName;
    }

    return GENERIC_LIST_NAME;
  };

  function getListPosition($element) {
    // for new product boxes
    const listPosition = $($element).closest('article').parent()
      .find('[data-product-box]')
      .index($element) + 1;
    if (listPosition > 0) {
      return listPosition;
    }
    // for old product boxes
    return $($element).closest('article').parent()
      .find('[data-legacy-product-box]')
      .index($element) + 1;
  }

  function getStockLevel(availability) {
    let stockLevel = 'N/A';

    if (availability <= 0) {
      stockLevel = 'Out Of Stock';
    } else if (availability >= 1 && availability <= 5) {
      stockLevel = 'Low Stock';
    } else if (availability >= 6) {
      stockLevel = 'In Stock';
    }

    return stockLevel;
  }

  function trackImpression(event, impressions) {
    if (!trackingDisabled) {
      dataLayer.push({ impressions: undefined });
      dataLayer.push({
        event,
        impressions,
      });
    }
    return mockTrackingApp;
  }

  function trackImpressionWithoutUndefined(event, impressions) {
    if (!trackingDisabled) {
      dataLayer.push({
        event,
        impressions,
      });
    }
    return mockTrackingApp;
  }

  /**
   * @param {String} eventCategory
   * @param {String} eventAction
   * @param {String} eventLabel
   */
  function trackInteractionEvent(eventCategory, eventAction, eventLabel, event = 'gaEvent', customerHash) {
    const data = {
      event,
      eventCategory,
      eventAction,
      eventLabel,
    };

    if (customerHash) {
      data.customerHash = customerHash;
    }

    dataLayer.push(data);
  }

  function trackNonInteractionEvent(eventCategory, eventAction, eventLabel, customerHash = null, callback = null) {
    trackInteractionEvent(eventCategory, eventAction, eventLabel, 'gaEventNonInteraction', customerHash, callback);
  }

  const getPackageSKU = function (productId, lensPackageSKU) {
    let packageSku = productId;
    if (lensPackageSKU) {
      packageSku = lensPackageSKU === -1 ? 'N/A' : lensPackageSKU;
    }
    return packageSku;
  };

  const convertLensParamsNames = function (params = {}) {
    Object.keys(params)
      .forEach((key) => {
        const newKey = App.product.paramsNamesLensesCartJson[key];
        if (newKey && params[key] !== '') {
          // eslint-disable-next-line no-param-reassign
          params[newKey] = params[key];
        }
        // eslint-disable-next-line no-param-reassign
        delete params[key];
      });
    return params;
  };

  /**
   * @function getLensPackageSkuFromQuickCart
   * @description - get packageSKU for LENS item that was added on product page.
   *                packageSKU is getting from quickCart items by prodID filtering.
   * @param {Number} prodID - product Id
   * @param {Object} currentProduct - lens product has been added to cart
   * @return {Array} productInfo - array of lens info objects : {eye, packageSKU}
   */
  const getLensPackageSkuFromQuickCart = function (prodID, currentProduct) {
    const quickCartItems = window.dataLayer.quickCartOrderInfo.cartItems;
    const selectedLensParams = currentProduct.checkCartJson
      ? currentProduct.checkCartJson().data
      : currentProduct.data;
    const productInfo = [];

    $.each(selectedLensParams, (eye, selectedParams) => {
      // eslint-disable-next-line consistent-return
      $.each(quickCartItems, (itemIndex, cartItem) => {
        const isCurrentProduct = +cartItem.productItem.productID === +prodID;
        let lensData = isCurrentProduct && $.extend({}, cartItem.selectedArticle.lensData);
        const lensPackageSKU = lensData && lensData.packageSKU;

        if (!isCurrentProduct) {
          // Continue to the next cartItem
          return true;
        }

        // eslint-disable-next-line no-param-reassign
        delete selectedParams.quantity;
        lensData = convertLensParamsNames(lensData);
        if (App.global.objectsAreEqual(selectedParams, lensData)) {
          productInfo.push({
            eye,
            packageSKU: getPackageSKU(null, lensPackageSKU),
          });
          // Break loop to next eye
          return false;
        }
      });
    });

    return productInfo;
  };

  function uaGlassLensIndex(glassLensIndex) {
    dataLayer.push({
      event: 'glassLensIndex',
      glassLensIndex,
    });
  }

  function uaPFProductsInView() {
    const products = [dataLayer.product, dataLayer.productPerfectFit];
    const productsInView = {
      event: 'productListView',
      products: [],
      index: null,
      listName: 'PerfectFit product page',
    };

    products.forEach((prod) => {
      productsInView.products.push({
        productId: prod.getCurrentProdId(),
      });
    });

    // eslint-disable-next-line no-use-before-define
    trackUpsellData(
      productsInView.event,
      productsInView.products,
      productsInView.index,
      productsInView.listName,
    );
  }

  function uaProductPFClick(event, prodInfo) {
    const product = {
      availability: 'N/A',
      id: prodInfo.id,
      groupId: prodInfo.groupId || '',
      name: prodInfo.name,
      category: prodInfo.prodType || 'N/A',
      categoryNameId: prodInfo.categoryNameId || 'N/A',
      subCategory: prodInfo.subCategory || 'N/A',
      manufacturer: prodInfo.manufacturer || 'N/A',
      price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
      listName: 'PerfectFit product page',
      listPosition: $('.js-pf-switcher.active').index('.js-pf-switcher') + 1,
      ribbon: getRibbon(prodInfo, 'N/A'),
    };

    dataLayer.push({
      event,
      product,
    });
  }

  function fetchAndTrackProductId(analyticsRequestedData, listName, listPosition) {
    const jqxhr = $.ajax({
      url: '/analytics',
      data: JSON.stringify(analyticsRequestedData),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    });

    jqxhr.done((data) => {
      analyticsCacheAdd(data.productInformation);
      const [productInfo] = data.productInformation;
      const product = {
        id: productInfo.productId,
        groupId: productInfo.groupId || '',
        name: productInfo.name,
        category: productInfo.category,
        categoryNameId: productInfo.categoryNameId || 'N/A',
        subCategory: productInfo.subcategory || 'N/A',
        manufacturer: productInfo.manufacturer || 'N/A',
        availability: getStockLevel(productInfo.inStockQuantity),
        price: Math.round((productInfo.price / ua.VAT) * 100) / 100,
        listName,
        listPosition,
        ribbon: getRibbon(productInfo),
      };

      dataLayer.push({
        event: 'productClick',
        product,
      });
    });

    return jqxhr;
  }

  function uaProductClick(elem) {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    const $elem = $(elem);
    const analyticsRequestedData = { productsData: [{ productId: parseInt($elem.data('id'), 10) }] };
    return fetchAndTrackProductId(analyticsRequestedData, getListName($elem), getListPosition($elem));
  }

  function trackError(errorMessage) {
    dataLayer.push({
      event: 'error',
      errorMessage,
    });
  }

  function fillProductsFields(data, extraData) {
    const { productInformation } = data;
    const { listPosition, listName: preassignedListName, $elem } = extraData || {};

    const products = !productInformation ? [] : productInformation.map((prodInfo) => {
      if (prodInfo.originalPrice === 0 && !prodInfo.excludedProduct && !prodInfo.isOrderDiscount) {
        return null;
      }

      const product = {
        id: prodInfo.productId,
        groupId: prodInfo.groupId || '',
        name: prodInfo.name,
        category: prodInfo.category,
        categoryNameId: prodInfo.categoryNameId || 'N/A',
        subCategory: prodInfo.subcategory || 'N/A',
        manufacturer: prodInfo.manufacturer || 'N/A',
        availability: getStockLevel(prodInfo.inStockQuantity),
        price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
        quantity: prodInfo.inCartQuantity || 1,
        packageSKU: getPackageSKU(prodInfo.productId),
        ribbon: getRibbon(prodInfo),
        lensesUnitSize: prodInfo.size || 'N/A',
        listName: preassignedListName || getListName(extraData && $elem),
        details: prodInfo.details || {},
      };

      if (ua.thanks) {
        product.priceFull = Math.round((prodInfo.originalPrice / ua.VAT) * 100) / 100;
        product.priceFullSEK = Math.round((prodInfo.originalPriceSEK / ua.VAT) * 100) / 100;
        if (App.global.objHasProp(prodInfo, 'addToCartDate')) {
          addCustomProperties(prodInfo, product, ['addToCartDate']);
        }
      }

      if (prodInfo.category === 'LENS') {
        product.packageSKU = getPackageSKU(prodInfo.productId, prodInfo.packageSKU);
      } else if (prodInfo.isReadingGlasses === true) {
        const { frameProduct } = prodInfo;
        if (frameProduct && frameProduct.power) {
          product.details.power = frameProduct.power;
        }
      }

      if (extraData && typeof listPosition !== 'undefined') {
        product.listPosition = listPosition;
      }

      return product;
    });

    return products.filter((p) => p !== null);
  }

  function uaLensChoiceData(addedProducts, extraData) {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    const productsData = [];
    addedProducts.forEach((p) => {
      const data = {
        productId: p.id,
      };
      productsData.push(data);
    });
    const jqxhr = $.ajax({
      url: '/analytics',
      data: JSON.stringify({ productsData }),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    });

    jqxhr
      .done((data) => {
        analyticsCacheAdd(data.productInformation);
        const products = fillProductsFields(data, extraData);

        dataLayer.push({
          event: 'cartAddMultiple',
          products,
        });
      })
      .fail((er) => {
        App.sendErrorToRaygun(er);
      });

    return jqxhr;
  }

  const triggerPushChanges = (props) => {
    const {
      event,
      currentProduct,
      prodInfo,
      quantityDelta,
    } = props;
    const lensPackageSKU = App.cartPage.isCart()
      ? currentProduct.isLens && currentProduct.selectedArticle.packageSKU
      : null;
    const productId = App.cartPage.isCart()
      ? currentProduct.productID
      : currentProduct.id;
    /* eslint-disable no-param-reassign */
    prodInfo.packageSKU = getPackageSKU(productId, lensPackageSKU);
    prodInfo.stockLevel = getStockLevel(prodInfo.inStockQuantity);
    prodInfo.quantity = quantityDelta || currentProduct.quantity || 1;
    /* eslint-enable no-param-reassign */
    if (currentProduct.analyticsUpgradeInCart) {
      const propsArray = ['listName', 'listPosition', 'upgradeFromId', 'upgradeFromName'];
      addCustomProperties(currentProduct.analyticsUpgradeInCart, prodInfo, propsArray);
      delete currentProduct.analyticsUpgradeInCart;
    }

    $(document)
      .trigger('uaPushChanges', {
        event,
        prodInfo,
      });
  };

  function uaGatherData(props) {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    const {
      currentProduct,
      event,
      quantityDelta = null,
    } = props;
    const isCartPage = App.cartPage.isCart();
    const analyticsRequestedData = {
      productsData: [{
        productId: isCartPage ? currentProduct.productID : currentProduct.id,
        quantity: currentProduct.quantity,
      }],
    };
    const jqxhr = $.ajax({
      url: '/analytics',
      data: JSON.stringify(analyticsRequestedData),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    });

    jqxhr.done((data) => {
      analyticsCacheAdd(data.productInformation);
      const [prodInfo] = data.productInformation;
      triggerPushChanges({
        event,
        prodInfo,
        currentProduct,
        quantityDelta,
      });
    });

    return jqxhr;
  }

  /**
   * Track Lens item that has been added in cart on product page
   * @param props
   * @param props.currentProduct - Main LENS product
   * @returns {{always(*=): void, then(*=): void}|jQuery}
   */
  function trackLensAddToCart(props) {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    const { currentProduct } = props;
    const { upsell } = currentProduct;
    const productsData = [{
      productId: currentProduct.id,
      quantity: currentProduct.getTotalQuantity(),
    }];

    if (upsell && upsell.forEach) {
      upsell.forEach((u) => {
        productsData.push({
          productId: String(u.itemID),
          quantity: u.quantity,
        });
      });
    }

    const jqxhr = $.ajax({
      url: '/analytics',
      data: JSON.stringify({ productsData }),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    });

    jqxhr.done((data) => {
      analyticsCacheAdd(data.productInformation);

      const products = [];

      // The products order in productInformation is the same as in productIds[].
      data.productInformation.forEach((prodInfo) => {
        const product = prodInfo;

        if (product.category === 'EXTRA') {
          const extendInfo = {
            stockLevel: getStockLevel(product.inStockQuantity),
            packageSKU: product.productId,
            quantity: 1,
          };
          products.push({ ...product, ...extendInfo });
          return;
        }

        // Fill analytics data for currentProduct LENS.
        const isPerfectFitActive = $('.js-pf-switcher.active').data('perfectfit');
        if (isPerfectFitActive) {
          product.upgradeFromName = dataLayer.product.name;
          product.upgradeFromId = dataLayer.product.getCurrentProdId();
        }
        const lensPackageSKU = getLensPackageSkuFromQuickCart(currentProduct.id, currentProduct);
        lensPackageSKU.forEach((info) => {
          const availability = currentProduct.inStockQuantity[info.eye];
          product.stockLevel = getStockLevel(availability);
          product.packageSKU = info.packageSKU;
          product.quantity = product.excludedProduct ? 1 : currentProduct.quantity[info.eye];
          products.push($.extend({}, product));
        });
      });

      if (products.length > 0) {
        $(document)
          .trigger('uaPushChanges', {
            event: 'cartAdd',
            prodInfo: products.length > 1 ? products : products[0],
            isMultiple: products.length > 1,
          });
      }
    });

    return jqxhr;
  }

  function pushEventToDataLayer(event) {
    if (!trackingDisabled) {
      dataLayer.push({
        event,
      });
    }
    return mockTrackingApp;
  }

  function trackUpsellData(event, data, index, listName) {
    const products = $.map(data, (item) => item.productId);
    const analyticsRequestedData = { productsData: [] };
    products.forEach((p) => analyticsRequestedData.productsData.push({ productId: p }));

    $.ajax({
      url: '/analytics',
      data: JSON.stringify(analyticsRequestedData),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success(resp) {
        const { productInformation } = resp;
        const prodInfoLength = productInformation && productInformation.length;
        let prodInfo = {};
        let analytics = {};
        const impressions = [];

        analyticsCacheAdd(productInformation);

        for (let y = 0; y < prodInfoLength; y += 1) {
          prodInfo = productInformation[y];

          analytics = {
            id: prodInfo.productId,
            groupId: prodInfo.groupId,
            name: prodInfo.name,
            category: prodInfo.category,
            categoryNameId: prodInfo.categoryNameId || 'N/A',
            subCategory: prodInfo.subcategory || 'N/A',
            manufacturer: prodInfo.manufacturer,
            availability: getStockLevel(prodInfo.inStockQuantity),
            listName: listName || upsellListName,
            listPosition: index || (y + 1),
            price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
            ribbon: getRibbon(prodInfo),
          };

          impressions.push(analytics);
        }
        trackImpression(event, impressions);
      },
    });
  }

  async function fetchAndTrackData(event, analyticsRequestedData, firstIndex, listName) {
    const { productInformation } = await fetch(analyticsRequestedData);
    const impressions = !productInformation ? [] : productInformation.map((prodInfo, index) => ({
      id: prodInfo.productId,
      groupId: prodInfo.groupId,
      name: prodInfo.name,
      category: prodInfo.category,
      categoryNameId: prodInfo.categoryNameId || 'N/A',
      subCategory: prodInfo.subcategory || 'N/A',
      manufacturer: prodInfo.manufacturer,
      availability: getStockLevel(prodInfo.inStockQuantity),
      listName: listName || upsellListName,
      listPosition: firstIndex ? (firstIndex + index + 1) : (index + 1),
      price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
      ribbon: getRibbon(prodInfo),
    }));
    trackImpressionWithoutUndefined(event, impressions);
  }

  function trackProductListViewById(event, data, firstIndex, listName) {
    const analyticsRequestedData = { productsData: [] };
    data.forEach((p) => analyticsRequestedData.productsData.push({ productId: p }));
    fetchAndTrackData(event, analyticsRequestedData, firstIndex, listName);
  }

  function uaUpdateProdList() {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    const impressions = [];
    const analyticsRequestedData = { productsData: [] };
    const $productList = $('#productList');
    const $productListLegacy = !$productList.length && $('#product_list');
    let $productItems = $productList.length
      ? $productList.find('.js-product-list-item')
      : $productListLegacy.find('.product_item:visible');

    if (App.settings.productBox) {
      $productItems = $productList.length
        ? $productList.find('[data-product-box]')
        : $productListLegacy.find('[data-product-box]:visible');
    }

    if ($productItems.length > 0) {
      if (App.settings.productBox) {
        $productItems
          .map((i, el) => el.getAttribute('data-id'))
          .get()
          .forEach((productId) => {
            analyticsRequestedData.productsData.push({ productId });
          });
      } else {
        $productItems
          .map((i, el) => $(el).find('.product-item').data('id'))
          .get()
          .forEach((productId) => {
            analyticsRequestedData.productsData.push({ productId });
          });
      }

      return $.ajax({
        url: '/analytics',
        data: JSON.stringify(analyticsRequestedData),
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success(data) {
          const { productInformation } = data;
          const prodInfoLength = productInformation && productInformation.length;
          let analytics = {};
          let prodInfo = {};

          if (!productInformation) {
            App.sendErrorToRaygun(
              `tracking.js: data.productInformation is empty! : ${JSON.stringify(data || {})}`,
            );
            return;
          }

          analyticsCacheAdd(productInformation);

          for (let y = 0; y < prodInfoLength; y += 1) {
            prodInfo = productInformation[y];

            analytics = {
              id: prodInfo.productId,
              groupId: prodInfo.groupId,
              name: prodInfo.name,
              category: prodInfo.category,
              categoryNameId: prodInfo.categoryNameId || 'N/A',
              subCategory: prodInfo.subcategory || 'N/A',
              manufacturer: prodInfo.manufacturer,
              availability: getStockLevel(prodInfo.inStockQuantity),
              listName: getListName(),
              listPosition: y + 1,
              price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
              ribbon: getRibbon(prodInfo),
            };

            impressions.push(analytics);
          }
          trackImpression('updateProdListPage', impressions);
        },
      });
    }

    return trackImpression('updateProdListPage', []);
  }

  async function trackSingleImpression($element) {
    const productId = $element.data('id');
    let prodInfo = analyticsCacheGet(productId);
    const analyticsRequestedData = {
      productsData: [{ productId }],
    };
    if (!prodInfo) {
      prodInfo = await $.ajax({
        url: '/analytics',
        data: JSON.stringify(analyticsRequestedData),
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      });
      analyticsCacheAdd(prodInfo.productInformation);
      prodInfo = analyticsCacheGet(productId);
    }

    const product = fillProductsFields({ productInformation: [prodInfo] }, {
      listPosition: getListPosition($element),
      $elem: $element,
    })[0];

    if (product && !impressionAlreadyTracked(product)) {
      saveTrackedImpression(product);
      impressionsQueue.push(product);
      debouncedPush();
    }
  }

  /**
   * @function uaUpdateCart
   * @description - track cart state after cartAdd or cartRemove events
   * @param {Array} analyticsProdInfo - analytics information
   * @returns {Object} mockTrackingApp - mocked object with Deferred callbacks
   */
  function uaUpdateCart(analyticsProdInfo) {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    const cart = analyticsProdInfo.map((analyticsInfo) => (
      {
        id: analyticsInfo.productId,
        groupId: analyticsInfo.groupId || '',
        name: analyticsInfo.name,
        category: analyticsInfo.category,
        categoryNameId: analyticsInfo.categoryNameId || 'N/A',
        subCategory: analyticsInfo.subcategory || 'N/A',
        manufacturer: analyticsInfo.manufacturer || 'N/A',
        availability: getStockLevel(analyticsInfo.inStockQuantity),
        price: Math.round((analyticsInfo.price / ua.VAT) * 100) / 100,
        quantity: analyticsInfo.inCartQuantity,
        ribbon: getRibbon(analyticsInfo),
        packageSKU: getPackageSKU(analyticsInfo.productId, analyticsInfo.packageSKU),
      }
    ));

    dataLayer.push({
      event: 'cartUpdate',
      cart,
    });

    return mockTrackingApp;
  }

  function uaAddCartItem(props) {
    const {
      event,
      analyticsProduct = null,
      currentProduct,
      quantityDelta = null,
    } = props;

    if (analyticsProduct) {
      triggerPushChanges({
        event,
        prodInfo: analyticsProduct,
        currentProduct,
        quantityDelta,
      });
      return mockTrackingApp;
    }

    return uaGatherData(props);
  }

  function uaRemoveCartItem(props) {
    const {
      event, cartItem, quantityDelta,
    } = props;
    const lensPackageSKU = cartItem.type === 'LENS' && cartItem.selectedArticle.packageSKU;
    const product = {
      id: cartItem.productID,
      groupId: cartItem.groupID || '',
      name: cartItem.name,
      category: cartItem.type,
      categoryNameId: cartItem.categoryNameId || 'N/A',
      subCategory: cartItem.factType || 'N/A',
      manufacturer: cartItem.brand || 'N/A',
      packageSKU: getPackageSKU(cartItem.productID, lensPackageSKU),
      price: Math.round((cartItem.price / ua.VAT) * 100) / 100,
      quantity: quantityDelta || cartItem.quantity,
    };
    addCustomProperties(cartItem, product, ['cartRemoveReason']);
    dataLayer.push({
      event,
      product,
    });

    return mockTrackingApp;
  }

  /**
   * Analytics may have several records with the same product: with normal price and zero price -
   * due to behaviours, for ex. n-th product for free.
   */
  const filterAnalyticsProduct = (props) => {
    const { analyticsProdInfo, cartItem } = props;

    if (!analyticsProdInfo) {
      return null;
    }

    const allAnalyticsProducts = analyticsProdInfo.filter((p) => (
      cartItem.type === App.product.Type.LENS
        ? p.packageSKU === cartItem.selectedArticle.packageSKU
        : p.productId === cartItem.productID
    ));
    const analyticsProductsWithPrice = allAnalyticsProducts.filter((p) => (
      Number.parseFloat(p.price) > 0
    ));

    return analyticsProductsWithPrice.length
      ? analyticsProductsWithPrice[0]
      : allAnalyticsProducts[0];
  };

  /**
   * @function uaTrackCartPageEvent
   * @description - track cart state after cartAdd or cartRemove events
   * @param {String} event - event name
   * @param {Object} cartItem - cart item
   * @param {Object} updateCartResp - updateCart/deleteFromCart cart services response
   * @param {Number} quantityDelta - item quantity that has been added/removed
   * @returns {Object} mockTrackingApp - mocked object with Deferred callbacks
   */
  function uaTrackCartPageEvent(event, cartItem, updateCartResp = null, quantityDelta = null) {
    if (trackingDisabled) {
      return mockTrackingApp;
    }

    let jqxhr = null;
    const analyticsProdInfo = updateCartResp
      ? updateCartResp.analyticsInformation.productInformation
      : null;

    if (event === 'cartAdd') {
      jqxhr = uaAddCartItem({
        event,
        currentProduct: cartItem,
        quantityDelta,
        analyticsProduct: filterAnalyticsProduct({ analyticsProdInfo, cartItem }),
      });
    } else if (event === 'cartRemove') {
      jqxhr = uaRemoveCartItem({
        event, cartItem, quantityDelta,
      });
    }

    if (jqxhr && analyticsProdInfo) {
      return jqxhr.always(() => {
        uaUpdateCart(analyticsProdInfo);
      });
    }
    return mockTrackingApp;
  }

  /**
   * Track Upgrade-in-cart ProductListView event
   * @param {jQuery} $banners - upgrade banners are shown
   */
  function uaUpgradeInCartListView($banners) {
    const impressions = [];
    $banners.each((index, banner) => {
      const productId = $(banner).data('id');
      const product = window.ua.prodInfo.filter((item) => item.productId === productId)[0];
      if (product) {
        impressions.push({
          id: product.productId,
          groupId: product.groupId || '',
          name: product.name,
          category: product.category,
          categoryNameId: product.categoryNameId || 'N/A',
          subCategory: product.subcategory || 'N/A',
          manufacturer: product.manufacturer || 'N/A',
          availability: getStockLevel(),
          listName: 'Upgrade list',
          listPosition: index + 1,
          price: Math.round((product.price / window.ua.VAT) * 100) / 100,
          ribbon: getRibbon(product),
        });
      }
    });
    trackImpression('productListView', impressions);
  }

  async function trackUpdateProdInView(productId) {
    let prodInfo = analyticsCacheGet(productId);
    if (!prodInfo) {
      const analyticsRequestedData = { productsData: [{ productId }] };
      prodInfo = await $.ajax({
        url: '/analytics',
        data: JSON.stringify(analyticsRequestedData),
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      });
      analyticsCacheAdd(prodInfo.productInformation);
      prodInfo = analyticsCacheGet(productId);
    }

    const product = fillProductsFields({ productInformation: [prodInfo] })[0];

    if (product) {
      delete product.quantity;

      dataLayer.push({
        event: 'productDetailUpdate',
        product,
      });
    }
  }

  function uaShowParameters() {
    if (!trackingDisabled) {
      dataLayer.push({
        event: 'showFrameParameters',
      });
    }
    return mockTrackingApp;
  }

  function getProductAnalytics(prodInfo, event) {
    const selector = App.settings.productBox ? '[data-product-box]' : '[data-legacy-product-box]';
    const $product = $(`${selector}[data-id="${prodInfo.productId}"]`);
    const propsArray = [
      'upgradeFromName',
      'upgradeFromId',
      'listName',
      'listPosition',
      'addToCartDate',
    ];
    const prodAnalytics = {
      id: prodInfo.productId,
      groupId: prodInfo.groupId || '',
      name: prodInfo.name,
      category: prodInfo.category,
      categoryNameId: prodInfo.categoryNameId || 'N/A',
      subCategory: prodInfo.subcategory || 'N/A',
      manufacturer: prodInfo.manufacturer || 'N/A',
      availability: prodInfo.stockLevel,
      ribbon: getRibbon(prodInfo),
      listName: getListName($product),
      listPosition: $product.closest('article').index() + 1,
      price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
      packageSKU: prodInfo.packageSKU,
      quantity: prodInfo.quantity,
    };
    if (event === 'cartAdd') {
      addCustomProperties(prodInfo, prodAnalytics, propsArray);
    }
    return prodAnalytics;
  }

  function setEventListeners() {
    $(document)
      .on('uaPushChanges', (e, data) => {
        const { event, isMultiple, prodInfo } = data;

        if (isMultiple) {
          const products = [];
          prodInfo.forEach((prod) => {
            const product = getProductAnalytics(prod, event);
            products.push(product);
          });
          dataLayer.push({
            event: 'cartAddMultiple',
            products,
          });
        } else {
          const product = getProductAnalytics(prodInfo, event);
          dataLayer.push({
            event,
            product,
          });
        }
      });

    if (getListName() === 'Cart page') {
      (function uaStep2Visible() {
        const $kcc = $('#klarna-checkout-container');
        const $cartDetailsForm = $('.cart-page__my-details-form');
        let $elem = $kcc.length ? $kcc : $cartDetailsForm;
        let i = 0;

        $elem = $elem.length ? $elem : $cartDetailsForm;

        $(window)
          .scroll(function scrollToCheckoutStep() {
            if (i !== 0) {
              return;
            }
            const $this = $(this);
            if ($elem.is(':visible') && $this.scrollTop() > $elem.offset().top - $this.height()) {
              dataLayer.push({
                event: 'checkoutStep',
                step: 2,
              });
              i += 1;
            }
          });
      }());
    }
  }

  /**
   * monitorProductImpressions tracks impressions on the fly when they become visible.
   */
  let intersectionObserver;
  function monitorProductImpressions() {
    if (!App.settings.monitorProductImpressions) {
      return;
    }

    // Ignore impressions tracking for unsupported browsers
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    if (intersectionObserver) {
      intersectionObserver.disconnect();
    }
    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.4) {
          entry.target.setAttribute('data-viewed', '');
          intersectionObserver.unobserve(entry.target);
          trackSingleImpression($(entry.target));
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.4,
    });

    const prodBoxes = App.settings.productBox ? '[data-product-box]' : '[data-legacy-product-box]';

    [...document.querySelectorAll(`${prodBoxes}:not([data-viewed])`)]
      .forEach((el) => intersectionObserver.observe(el));
  }

  function init() {
    if (trackingDisabled) {
      return;
    }

    setEventListeners();

    if (document.createEvent) {
      const event = document.createEvent('Event');
      event.initEvent('analyticsLoaded', true, false);
      document.dispatchEvent(event);
    } else {
      document.dispatchEvent(new window.CustomEvent('analyticsLoaded'));
    }

    window.detectPrivateMode((isPrivate) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'checkPrivateMode',
        isPrivateMode: (!!isPrivate).toString(),
      });
    });

    if (App.settings.monitorProductImpressions) {
      monitorProductImpressions();
      debouncedPush = window.debounce(() => {
        trackImpression('productListView', impressionsQueue);
        impressionsQueue = [];
      }, 100);
    }

    TrackApp.reorder.init();
    TrackApp.promoTracking.init();
  }

  $.extend(TrackApp, {
    addCustomProperties,
    init,
    fetch,
    getListName,
    getListPosition,
    getPackageSKU,
    isTrackingDisabled,
    trackCartPageEvent: uaTrackCartPageEvent,
    trackUpgradeInCartListView: uaUpgradeInCartListView,
    trackProductClick: uaProductClick,
    trackUpdateProdList: uaUpdateProdList,
    trackUpdateProdInView,
    pushEventToDataLayer,
    trackGatherData: uaGatherData,
    trackLensAddToCart,
    trackShowParameters: uaShowParameters,
    trackUpsellData,
    trackProductListViewById,
    trackInteraction: trackInteractionEvent,
    trackNonInteractionEvent,
    trackImpression,
    trackImpressionWithoutUndefined,
    trackGlassLensIndex: uaGlassLensIndex,
    trackLensChoiceAddToCart: uaLensChoiceData,
    trackPFClick: uaProductPFClick,
    trackPFProductsInView: uaPFProductsInView,
    monitorProductImpressions,
    analyticsCacheAdd,
    analyticsCacheGet,
    mockTrackingApp,
    getStockLevel,
    getRibbon,
    trackError,
    fillProductsFields,
    disabled: !window.trackingEnabled,
  });
})();
